import { type FC } from "react";

import { generateVariantStyles } from "../../../../app-utils/track-shapes/shape-variant.js";
import { VariantSymbol } from "../../../genome-viewer/variants-track/VariantSymbol.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const VariantTypeCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const symbolStyle: any = generateVariantStyles(props.value).symbolElementStyle;

  return (
    <TableCell icon={<VariantSymbol styleContent={symbolStyle} type={props.value} width={12} />}>
      {props.value}
    </TableCell>
  );
};

export default VariantTypeCell;
